import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { EmployeeReviewTemplateService } from '../../../../core/services/employee-review-template.service';
import { KraMetricResult, metricResultStatuses, metricScoreStatuses, metricRatingStatuses } from '../../../../models/kraMetricModels';

@Component({ selector: 'app-metric-results', templateUrl: './metric-results.component.html', standalone: false })
export class MetricResultsComponent extends BaseComponent implements OnInit {
  results: KraMetricResult[] = [];
  loading = true;
  error = '';
  reviewListUserID: number;
  statuses = metricResultStatuses;
  scoreStatuses = metricScoreStatuses;
  ratingStatuses = metricRatingStatuses;
  constructor(private route: ActivatedRoute, private service: EmployeeReviewTemplateService, private store: Store<State>) { super(); }
  ngOnInit() {
    const userID = Number(this.route.snapshot.params.userid || 0);
    this.reviewListUserID = userID;
    if (!userID) {
      this.subs.push(this.store.select(s => s.accountState.user).subscribe(user => { this.reviewListUserID = user?.id; }));
    }
    this.subs.push(this.service.getMetricResults(userID).subscribe({ next: results => { this.results = results; this.loading = false; },
      error: err => { this.loading = false; this.error = typeof err.error === 'string' ? err.error : err.error?.message || err.message; } }));
  }
}
